import { fetchJSON } from './getFetchReusable';
import { API_CORE_URL } from '../constantes/constantes';

/**
 * Obtiene la da de hoy en el hub
 * 
 */
export async function getTodayEvents() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const date = `${year}-${month}-${day}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const url = `${API_CORE_URL}events-by-filters?date=${encodeURIComponent(date)}&timezone=${encodeURIComponent(timezone)}`;
  return await fetchJSON(url);
}

/**
 * Obtiene la data del carrousel home
 */
export async function getAll() {
  return await fetchJSON(`${API_CORE_URL}events-manually`);
}